import { createContext } from "react";

export interface IHistoryExerciseListModalContext {
  exerciseListModalOpen: boolean;
  setExerciseListModalOpen: (open: boolean) => void;
}

const HistoryExerciseListModalContext = createContext<
  IHistoryExerciseListModalContext | undefined
>(undefined);

export default HistoryExerciseListModalContext;
